import { PlusOutlined } from '@ant-design/icons'
import { SORTER_OPTIONS } from '@configs'
import { t } from 'i18next'
import { Button, Input, SharedTable } from 'src/common'
import { SearchIcon } from 'src/components/Icon'
import { ShareSelectInput } from 'src/components/shared'
import ConfirmDeleteModal from 'src/components/staff-and-role-management/ConfirmDeleteModal'
import { useListWorkshopEventTable } from './useListWorkshopEventTable'

interface IProps {
  onAddNew: () => void
}
const ListWorkshopEventTable = ({ onAddNew }: IProps) => {
  const {
    jobs,
    columns,
    searchString,
    setSearchString,
    totalJob,
    getListJob,
    currentPage,
    isGettingWorkshopEvent,
    handleClear,
    deleteId,
    setDeleteId,
    isDeleting,
    onDelete,
    sorter,
    setSorter,
  } = useListWorkshopEventTable()

  return (
    <>
      <>
        <div className="flex items-center justify-between py-[1.25rem] w-full">
          <div className="flex items-center gap-x-2 w-fit">
            <Input
              className="pl-5 !h-10 "
              value={searchString}
                maxLength={100}
              onChange={(e) => setSearchString(e.target.value)}
              containerClassName="min-w-[300px]"
              placeholder={t('evolveLanding:search_workshopEvent')}
              prefix={<SearchIcon className="pl-2" />}
            />
            <ShareSelectInput
              containerClassName="flex flex-col gap-[10px] !min-w-[130px] w-[30%]"
              inlineLabelClassName="!text-start !block !m-0"
              placeholder="Sort by Date"
              data={SORTER_OPTIONS}
              onChange={(value: any) => {
                setSorter(value)
              }}
              value={sorter as any}
              showArrow
            />
          </div>
          <div className="flex gap-x-2">
            <Button
              htmlType="submit"
              type="primary"
              size="middle"
              className="!bg-red-500 !border-none h-10"
              style={{
                alignSelf: 'flex-end',
              }}
              onClick={handleClear}
            >
              {'Clear filter'}
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="middle"
              className="submit__btn loginselected-btn"
              icon={<PlusOutlined className="!text-[16px]" />}
              style={{
                alignSelf: 'flex-end',
              }}
              onClick={() => {
                onAddNew()
              }}
            >
              {'Add new'}
            </Button>
          </div>
        </div>
        <SharedTable
          rowKey="key"
          className="lg:!max-h-[60vh]"
          columns={columns}
          dataSource={jobs?.map((item: any, index: any) => {
            return {
              ...item,
              key: item?.id,
            }
          })}
          paginationProps={{
            total: !!totalJob ? +totalJob : undefined,
            pageSize: 10,
            current: currentPage || 1,
            onChange(page) {
              const params: { page: number, sort?: string } = {
                page: page, 
                sort: sorter ? `start:${sorter}` : undefined,
              }
              getListJob(params)
            },
          }}
          tableProps={{ loading: isGettingWorkshopEvent }}
          sticky
        />
        {/* )} */}
        <ConfirmDeleteModal
          title="Delete this workshop event"
          content="Are you sure to delete this workshop event?"
          open={Boolean(deleteId)}
          onClose={() => setDeleteId('')}
          isLoading={isDeleting || false}
          onDelete={onDelete}
        />
      </>
    </>
  )
}

export default ListWorkshopEventTable
